import { Box, Divider, List, ListItemButton, styled } from '@mui/material';
import Scrollbar from 'components/ScrollBar';
import { H6, H7 } from 'components/Typography';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { MenuData } from './menu-data';

// custom styled components
const SidebarWrapper = styled(Box)(({ theme }) => ({
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.background.paper,
}));

const StyledListItemButton = styled(ListItemButton, {
  shouldForwardProp: prop => prop !== 'active',
})(({ active, theme }) => ({
  padding: '12px 24px',
  marginBottom: 0,
  backgroundColor: active ? theme.palette.primary.grey10 : 'transparent',
  borderBottom: `1px solid ${theme.palette.primary.borderColor || '#E1E1E1'}`,
  '&:hover': {
    backgroundColor: theme.palette.grey[50],
  },
}));

export default function MenuContent() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleMenuClick = path => {
    if (path) navigate(path);
  };

  const mainSidebarContent = (
    <List
      sx={{
        height: '100%',
        padding: 0,
      }}
    >
      {MenuData.map((item, index) => {
        // Divider
        if (item.title === 'divider') {
          return (
            <Divider
              key={`divider-${index}`}
              sx={{ borderColor: '#E1E1E1', my: 2 }}
            />
          );
        }

        // Section Title
        if (item.sectionTitle) {
          return (
            <Box
              key={`section-${item.title || index}`}
              sx={{
                padding: '12px 24px',
                backgroundColor: theme => theme.palette.grey[100],
                borderBottom: theme =>
                  `1px solid ${theme.palette.primary.borderColor || '#E1E1E1'}`,
              }}
            >
              <H6
                lineHeight={1.5}
                fontWeight={600}
                sx={{
                  color: theme => theme.palette.primary.mainBlue,
                }}
              >
                {t(item.title)}
              </H6>
            </Box>
          );
        }

        // Regular menu item
        const isActive = item.path ? pathname.includes(item.path) : false;

        return (
          <StyledListItemButton
            key={`menu-${item.title || index}`}
            disableRipple
            active={isActive ? 1 : 0}
            onClick={() => handleMenuClick(item.path)}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
              }}
            >
              {item.Icon && (
                <item.Icon
                  sx={{
                    fontSize: 22,
                    color: theme =>
                      isActive
                        ? theme.palette.primary.mainBlue
                        : theme.palette.primary.greytxt ||
                          theme.palette.grey[500],
                  }}
                />
              )}
              <H7
                lineHeight={1.5}
                fontWeight={450}
                sx={{
                  color: theme =>
                    isActive
                      ? theme.palette.primary.mainBlue
                      : theme.palette.text.primary,
                }}
              >
                {t(item.title)}
              </H7>
            </Box>
          </StyledListItemButton>
        );
      })}
    </List>
  );

  const sideBarContent = (
    <Scrollbar autoHide clickOnTrack={false}>
      {mainSidebarContent}
    </Scrollbar>
  );

  return <SidebarWrapper>{sideBarContent}</SidebarWrapper>;
}
